import { render, staticRenderFns } from "./CitiesForm.vue?vue&type=template&id=4bb21e9b&scoped=true"
import script from "./CitiesForm.vue?vue&type=script&lang=js"
export * from "./CitiesForm.vue?vue&type=script&lang=js"
import style0 from "./CitiesForm.vue?vue&type=style&index=0&id=4bb21e9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb21e9b",
  null
  
)

export default component.exports